import React from "react";
import { BRANDS } from "../mock";

const BrandMarquee = () => {
  const list = [...BRANDS, ...BRANDS];
  return (
    <div className="relative py-8 border-y border-white/5 bg-[#0b0b0e] overflow-hidden">
      <div className="absolute left-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-r from-[#0b0b0e] to-transparent" />
      <div className="absolute right-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-l from-[#0b0b0e] to-transparent" />
      <div className="flex whitespace-nowrap animate-marquee">
        {list.map((brand, i) => (
          <div key={i} className="flex items-center mx-8 md:mx-12">
            <span className="font-display font-bold text-lg md:text-2xl text-white/25 tracking-wide hover:text-white/60 transition-colors">
              {brand}
            </span>
            <span className="ml-8 md:ml-12 w-1.5 h-1.5 rounded-full bg-[#ff6a00]/60" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default BrandMarquee;
